import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoSocialMediaSharedComponent } from './no-social-media-shared.component';
import { RappiderAlertModule, RappiderHeadingModule, RappiderTextModule, RappiderSwitchModule } from '@rappider/rappider-components';


@NgModule({
  imports: [
    CommonModule,
    RappiderAlertModule,
    RappiderHeadingModule,
    RappiderTextModule,
    RappiderSwitchModule
  ],
  declarations: [
    NoSocialMediaSharedComponent
  ],
  exports: [
    NoSocialMediaSharedComponent
  ]
})
export class NoSocialMediaSharedModule { }
